export const enum UserRoles {
  Admin = 'admin',
  Limited = 'limited',
  OpalAdmin = 'opal_admin',
  Owner = 'owner',
  Publisher = 'publisher',
  User = 'user',
  Viewer = 'view_only',
}
